import React from "react";
import { Button } from "../../../components/Button/Button";

interface StatusChipProps {
  background: string;
  text: string;
  textColor: string;
  icon: React.ReactNode;
  onClick: () => void;
}

const ProjectStatusBtn: React.FC<StatusChipProps> = ({
  background,
  text,
  textColor,
  icon,
  onClick,
}) => (
  <Button
    className="!flex !min-w-fit items-center gap-2 rounded-full px-3 !py-1 text-[14px] font-bold"
    style={{ backgroundColor: background, color: textColor }}
    onClick={onClick}
  >
    <span
      className="w-4 h-4 flex items-center justify-center"
      style={{ color: textColor }}
    >
      {icon}
    </span>
    <span>{text}</span>
  </Button>
);

export default ProjectStatusBtn;
